import { PropertiesPanelSection } from "@skilitics/designer-ui-components";
import { useFormatMessage } from "@skilitics/localization";

import { useSetSelectedNodeId } from "../../selection";
import { ElementStateForm } from "./ElementStateForm";
import { ElementStateOverridesList } from "./ElementStateOverridesList";
import type { ElementStateKey, ElementStateOption, StylesByElementState } from "./types";

type Props = {
  nodeId: number;
  allowedOptions: ElementStateOption[];
  stylesByElementState?: StylesByElementState;
  nodeReferences?: Record<string, number>;
  onRemove: (elementStateKey: ElementStateKey, otherNodeRefKey?: string) => void;
  disableTransition?: boolean;
};

export const ElementStatePropertiesSection = ({
  nodeId,
  allowedOptions,
  stylesByElementState,
  nodeReferences,
  onRemove,
  disableTransition,
}: Props) => {
  const formatMessage = useFormatMessage(formatStrings);
  const setSelectedNodeId = useSetSelectedNodeId();

  const hasElementStateOverrides = Object.keys(stylesByElementState ?? {}).length > 0;

  const handleSelectNodeRef = (nodeRef: string) => {
    const id = nodeReferences?.[nodeRef];
    if (id) {
      setSelectedNodeId(id);
    }
  };

  if (!allowedOptions.length) {
    return null;
  }

  return (
    <PropertiesPanelSection
      title={formatMessage("sectionHeader")}
      collapsible
      defaultCollapsed={!hasElementStateOverrides}
    >
      <ElementStateForm nodeId={nodeId} allowedOptions={allowedOptions} disableTransition={disableTransition} />

      {hasElementStateOverrides && (
        <ElementStateOverridesList
          onRemove={onRemove}
          stylesByElementState={stylesByElementState!}
          onSelectNodeRef={handleSelectNodeRef}
        />
      )}
    </PropertiesPanelSection>
  );
};

const formatStrings = {
  sectionHeader: {
    en: "Element States",
  },
};
